/* eslint-disable */
/**
 * StorageMemoryAdapter
 * @class StorageMemoryAdapter
 * @implements {StorageServiceAdapterContract}
 */
class StorageMemoryAdapter {
  /**
   * Creates an instance of `StorageMemoryAdapter`
   * @param {StorageServiceMemoryAdapterCreateDto} dto The params required to create an instance of `StorageMemoryAdapter`
   * @memberof StorageMemoryAdapter
   */
  constructor({ store = {} }) {
    this._store = store;
  }

  /**
   * Retrieve a value from the store by a `key`
   * @param {string} key The path of the property to get
   * @returns {null | string} The `value` from the store or `null` if it is not found within the store
   * @memberof StorageMemoryAdapter
   */
  getItem = (key) => {
    const value = this._store[key];
    if (value === undefined) {
      return null;
    }
    return value;
  };

  /**
   * Remove an item from the store by a `key`
   * @param {string} key The path of the `value` to remove
   * @returns {void} void
   * @memberof StorageMemoryAdapter
   */
  removeItem = (key) => {
    delete this._store[key];
  };

  /**
   * Store a given `value` by a `key`
   * @param {string} key The path of where to store the `value`
   * @param {any} value The `value` to store
   * @returns {void} void
   * @memberof StorageMemoryAdapter
   */
  setItem = (key, value) => {
    this._store[key] = value;
  };
}

export default StorageMemoryAdapter;
